import './index.scss';
import React from 'react';
import { translate } from '@utils';

export const QHeader = ({ labels }) => {
  return (
    <div className="q-header-container">
      <h2 className="q-header-title">{translate('q_header_title')}!</h2>
      <p className="q-header-text">
        {labels.map((label) => (
          <React.Fragment key={label}>
            {label}
            <br />
          </React.Fragment>
        ))}
      </p>
    </div>
  );
};
